import { createApiClient } from '@energovizor/api-client';
import backend from './backend';

export const apiClient = createApiClient(backend);